export default "__VITE_ASSET___yRU8alL__"